import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class LoginService extends BaseService {

  PATH_OF_API = environment.BaseApiUrl;

  constructor(public httpClient: HttpClient, authService: AuthService) {
    super(authService);
  }

  //Login
  public login(loginData: any): Observable<any> {
    const headers = new HttpHeaders({
      'X-Content-Type-Options': 'nosniff' // Setting the X-Content-Type-Options header
    });
    return this.httpClient.post<any>(this.PATH_OF_API + '/Authorise', loginData, { headers });
  }

  //Register
  public register(registerData: any): Observable<any> {
    return this.httpClient.post<any>(this.PATH_OF_API + '/Customer', registerData)
  }

  //User Details
  public details(token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.httpClient.get<any>(this.PATH_OF_API + '/Customer', { headers: headers });
  }

  //profile
  public profile(mail: any, token: string): Observable<any> {
    token = this.authService.getToken();
    var mail = this.authService.getRegistredUserDetails().email;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.httpClient.get<any>(this.PATH_OF_API + '/Customer/profile?mail=' + mail, { headers: headers });
  }

  //user list
  public userList(token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.httpClient.get<any>(this.PATH_OF_API + '/Users/list', { headers: headers });
  }

  //update user profile
  public updateProfile(details: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.httpClient.put<any>(this.PATH_OF_API + '/Customer', details, { headers: headers });
  }

  //create customer bank account
  public createBankAccount(bankData: any, token: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.post<any>(this.PATH_OF_API + '/CustomerBankAccount', bankData, { headers: headers });
  }

  //bank routing number
  public createBankAccountRoutingNum(routingNum: any, token: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.get<any>(this.PATH_OF_API + '/CustomerBankAccount/BankDetailsByRoutingNumber?routingNumber=' + routingNum, { headers: headers });
  }



  //update customer bank account
  public updateBankAccount(bankData: any, token: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.put<any>(this.PATH_OF_API + '/CustomerBankAccount', bankData, { headers: headers });
  }

  //delete customer bank account
  public deleteBankAccount(id: any, token: string): Observable<any> {

    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.delete<any>(this.PATH_OF_API + '/CustomerBankAccount?companyRegistrationId=' + id, { headers: headers });
  }

  //create customer Company details
  public createCompanyDetails(companyData: any, token: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.post<any>(this.PATH_OF_API + '/CustomerCompanyDetails', companyData, { headers: headers });
  }

  //update customer company details
  public updateCompanyDetails(companyData: any, token: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.put<any>(this.PATH_OF_API + '/CustomerCompanyDetails', companyData, { headers: headers });
  }

  //delete customer company details
  public deleteCompanyDetails(id: any, token: string): Observable<any> {
    // const id = this.authService.getCompanyDetails().companyId;
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.delete<any>(this.PATH_OF_API + '/CustomerCompanyDetails?companyId=' + id, { headers: headers });
  }

  //display customer company details by companyId
  public displayCompanyDetailsById(companyId: any, token: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.get<any>(this.PATH_OF_API + '/CustomerCompanyDetails?companyId=' + companyId, { headers: headers });
  }

  //display customer bank details by companyRegistrationId
  public displayBankDetailsById(companyRegistrationId: any, token: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.get<any>(this.PATH_OF_API + '/CustomerBankAccount?companyRegistrationId=' + companyRegistrationId, { headers: headers });
  }

  //display All Bank Account
  public allBankDetails(custId: any, token: string): Observable<any> {
    custId = this.authService.getRegistredUserDetails().customerId;
    token = this.authService.getToken();
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.get<any>(this.PATH_OF_API + '/CustomerBankAccount/list?customerId=' + custId, { headers: headers });
  }

  //display All company details
  public allCompanyDetails(token: string): Observable<any> {
    token = this.authService.getToken();
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.get<any>(this.PATH_OF_API + '/CustomerCompanyDetails/list', { headers: headers });
  }


  //change password
  public changePassword(forgotData: any, token: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.post<any>(this.PATH_OF_API + '/Users/ChangePassword', forgotData, { headers: headers });
  }

  //upload user logo
  public uploadLogo(file: File): Observable<Object> {
    const formData: FormData = new FormData();
    formData.append('avatar', file, file.name);
    return this.httpClient.post(this.baseUrl + '/Customer/upload', formData,
      this.headerWithTokenFile()).pipe(map(res => res));
  }

  //get logo
  public getLogo(filename: any, token): Observable<Object> {
    token = this.authService.getToken();
    return this.httpClient.get(this.baseUrl + '/Customer/image?fileName=' + filename,
      this.headerWithTokenGetFiles(token)).pipe(map(res => res));
  }

  //update public profile
  public updatePublicProfile(logodata: any, token: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.post<any>(this.PATH_OF_API + '/Customer/public', logodata, { headers: headers });
  }

  //reset logo
  public resetLogo(resetData: any, token: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/xml',
        'Authorization': `Bearer ${token}`
      })
    var raw = '<string>' + resetData + '</string>';
    return this.httpClient.post<any>(this.PATH_OF_API + '/Customer/reset', raw, { headers: headers });
  }

  //forgot pass
  public forgotPassword(email: any): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/xml'
      })
    var raw = '<string>' + email + '</string>';
    return this.httpClient.post<any>(this.PATH_OF_API + '/Users/forgotpassword', raw, { headers: headers });
  }

  //resetPassword
  public resetPassword(resetData: any, token: any): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.post<any>(this.PATH_OF_API + '/Users/resetpassword', resetData, { headers: headers });
  }

  public csrfToken() {
    return this.httpClient.get(this.baseUrl + '/W9Documents/csrf-token',
      this.headerWithToken()).pipe(map(res => res));
  }

  //disclaimer
  public desClaimer(diclaimer: any, token: string, csrf: any): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-CSRF-TOKEN': csrf
      })
    return this.httpClient.post<any>(this.PATH_OF_API + '/Customer/productsetting/disclaimer', diclaimer, { headers: headers });
    // return this.httpClient.post(this.baseUrl + '/Users/productsetting/disclaimer', diclaimer,
    //   this.headerWithCSRFTokenFile(csrf)).pipe(map(res => res));
  }

  public country(token: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      })
    return this.httpClient.get<any>('https://restcountries.com/v3.1/all', { headers: headers });
  }

}